import { jsxs, jsx } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import * as React from "react";
import { forwardRef } from "react";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { color } from "@creditornot/cb-ingredients/design-tokens";
import "./style.css";
const Root$2 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_InputRadio_Root_r463",
  propsAsIs: false
});
const BG = /* @__PURE__ */ styled("div")({
  name: "BG",
  class: "cb_InputRadio_BG_b16w",
  propsAsIs: false
});
const CheckedFill = /* @__PURE__ */ styled("div")({
  name: "CheckedFill",
  class: "cb_InputRadio_CheckedFill_c5ha",
  propsAsIs: false
});
const IconContainer = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_InputRadio_IconContainer_i17w",
  propsAsIs: false
});
const Input = /* @__PURE__ */ styled("input")({
  name: "Input",
  class: "cb_InputRadio_Input_ij2a",
  propsAsIs: false
});
const InputRadio = ({
  checked,
  className,
  disabled,
  disableFocusAndActiveStyles,
  inputClassName,
  inputStyle,
  style,
  ...rest
}, ref) => /* @__PURE__ */ jsxs(Root$2, {
  className,
  style,
  children: [/* @__PURE__ */ jsx(Input, {
    ...rest,
    checked,
    className: inputClassName,
    "data-fs": disableFocusAndActiveStyles ? void 0 : "",
    disabled,
    ref,
    style: inputStyle,
    type: "radio"
  }), /* @__PURE__ */ jsx(BG, {}), /* @__PURE__ */ jsx(IconContainer, {
    children: /* @__PURE__ */ jsx(CheckedFill, {})
  })]
});
const InputRadio$1 = forwardRef(InputRadio);
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Radio_Root_raev",
  propsAsIs: false
});
const TextLabel = /* @__PURE__ */ styled("span")({
  name: "TextLabel",
  class: "cb_Radio_TextLabel_t209",
  propsAsIs: false
});
const Content$1 = /* @__PURE__ */ styled("span")({
  name: "Content",
  class: "cb_Radio_Content_cf2s",
  propsAsIs: false
});
const Label = /* @__PURE__ */ styled("label")({
  name: "Label",
  class: "cb_Radio_Label_ljin",
  propsAsIs: false
});
const Radio = React.forwardRef(({
  checked,
  children,
  className,
  disabled,
  id,
  inputProps,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  readOnly,
  required,
  rootRef,
  style,
  value
}, ref) => /* @__PURE__ */ jsx(Root$1, {
  className,
  ref: rootRef,
  style,
  children: /* @__PURE__ */ jsxs(Label, {
    "aria-disabled": disabled ? true : void 0,
    htmlFor: id,
    children: [/* @__PURE__ */ jsx(InputRadio$1, {
      ...inputProps,
      checked,
      disabled,
      id,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      readOnly,
      ref,
      required,
      value
    }), children !== void 0 && /* @__PURE__ */ jsx(Content$1, {
      children: typeof children === "string" ? /* @__PURE__ */ jsx(TextLabel, {
        className: typographyClassName.Body3,
        children
      }) : children
    })]
  })
}));
Radio.displayName = "Radio";
const Radio$1 = Radio;
const _exp = () => ({
  $checked
}) => $checked ? color.borderSelected : color.border;
const Root = /* @__PURE__ */ styled("label")({
  name: "Root",
  class: "cb_RadioCard_Root_rquy",
  propsAsIs: false,
  vars: {
    "rquysqh-0": [_exp()]
  }
});
const LeftCol = /* @__PURE__ */ styled("div")({
  name: "LeftCol",
  class: "cb_RadioCard_LeftCol_l1mw",
  propsAsIs: false
});
const RightCol = /* @__PURE__ */ styled("div")({
  name: "RightCol",
  class: "cb_RadioCard_RightCol_r1tu",
  propsAsIs: false
});
const Header = /* @__PURE__ */ styled("div")({
  name: "Header",
  class: "cb_RadioCard_Header_hgi3",
  propsAsIs: false
});
const RadioContainer = /* @__PURE__ */ styled("div")({
  name: "RadioContainer",
  class: "cb_RadioCard_RadioContainer_r1sb",
  propsAsIs: false
});
const InputLabel = /* @__PURE__ */ styled("span")({
  name: "InputLabel",
  class: "cb_RadioCard_InputLabel_i6hs",
  propsAsIs: false
});
const Content = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_RadioCard_Content_c18d",
  propsAsIs: false
});
const TextContent = /* @__PURE__ */ styled("span")({
  name: "TextContent",
  class: "cb_RadioCard_TextContent_t1rl",
  propsAsIs: false
});
const RadioCard = React.forwardRef(({
  checked = false,
  className,
  disabled = false,
  inputProps,
  label,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  readOnly,
  required,
  rightContent,
  rootRef,
  style,
  subContent,
  title,
  value
}, ref) => /* @__PURE__ */ jsxs(Root, {
  $checked: checked,
  "aria-disabled": disabled ? true : void 0,
  className,
  ref: rootRef,
  style,
  title,
  children: [/* @__PURE__ */ jsxs(LeftCol, {
    children: [/* @__PURE__ */ jsxs(Header, {
      children: [/* @__PURE__ */ jsx(RadioContainer, {
        children: /* @__PURE__ */ jsx(InputRadio$1, {
          ...inputProps,
          checked,
          disableFocusAndActiveStyles: true,
          disabled,
          name,
          onBlur,
          onChange,
          onClick,
          onFocus,
          readOnly,
          ref,
          required,
          value
        })
      }), /* @__PURE__ */ jsx(InputLabel, {
        className: typographyClassName.Body3,
        children: label
      })]
    }), typeof subContent === "string" ? /* @__PURE__ */ jsx(Content, {
      children: /* @__PURE__ */ jsx(TextContent, {
        className: typographyClassName.Small,
        children: subContent
      })
    }) : /* @__PURE__ */ jsx(Content, {
      children: subContent
    })]
  }), !!rightContent && /* @__PURE__ */ jsx(RightCol, {
    children: rightContent
  })]
}));
RadioCard.displayName = "RadioCard";
const RadioCard$1 = RadioCard;
export {
  InputRadio$1 as InputRadio,
  Radio$1 as Radio,
  RadioCard$1 as RadioCard
};
//# sourceMappingURL=index.js.map
